import { render } from "./MainView.vue?vue&type=template&id=587c88c2"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__